import { Texture, TextureLoader } from 'three';

export const extractMesh = (gltfScene) => {
    let mesh = null;
    gltfScene.traverse((child) => {
        if (!mesh && child.isMesh && child.geometry) {
            mesh = child;
        }
    });
    return mesh;
};


export function gradTexture([stops, colors]) {

    const size = 1024;
    const canvas = Object.assign(document.createElement('canvas'), { width: 16, height: size });
    const ctx = canvas.getContext('2d');

    const gradient = ctx.createLinearGradient(0, 0, 0, size);
    for (let i = 0; i < stops.length; i++) {
        gradient.addColorStop(stops[i], colors[i]);
    }

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const texture = new Texture(canvas);
    texture.needsUpdate = true;

    return texture;
}

const CLOUD_SPRITE_FILES = [
    'cloud-01.png',
    'cloud-02.png',
    'cloud-03.png',
    'cloud-04.png',
    'cloud-05.png',
    'cloud-06.png',
    'cloud-07.png',
    'cloud-08.png',
    'cloud-09.png',
    'cloud-10.png',
    'cloud-11.png',
    'cloud-12.png',
    'cloud-13.png',
    'cloud-14.png',
    'cloud-15.png',
    'cloud-16.png',
    'cloud-17.png',
];

export function loadCloudTextures(assetDirectory) {
    const loader = new TextureLoader();
    return Promise.all(
        CLOUD_SPRITE_FILES.map((file) => loader.loadAsync(assetDirectory + 'clouds/' + file))
    );
}
